import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { parseCpaQueryParamsFromUrl, ROUTER_URLS } from '@portal/common';
import { OrderStepperService } from '@portal/ui-services';
import { ServiceCode } from '@shared/ui-service';
import { HomePageComponent } from '../components/home-page/home-page.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: HomePageComponent,
  },
  {
    path: ROUTER_URLS.serviceOrder,
    redirectTo: (): string => {
      const orderStepperService = inject(OrderStepperService);
      /*
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=200+Lake+St&latitude=44.4802555&longitude=-73.2209609&code=code=S0007
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=200+Lake+St&latitude=44.4802555&longitude=-73.2209609&code=code=S0009
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=200+Lake+St&latitude=44.4802555&longitude=-73.2209609&code=S1003
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=200+Lake+St&latitude=44.4802555&longitude=-73.2209609&code=S0005&customerType=Commercial
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=200+Lake+St&latitude=44.4802555&longitude=-73.2209609&code=S0009&customerType=Residential
      Residential Bulk with disposal items (S0001):
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0001&bulkItems=3dac4f68-1e23-44a1-89b9-20f1c82ccdb2:1,1dcfdd7b-0892-41c8-8bd8-5e45c05717ed:2&pickupDate=This%20week

      Residential Trash with service details pre-selection (S0009):
      - Residential Trash with full params (containerSize=96, frequency=Weekly, quantity=2, startDate)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0009&trashContainerSize=96&trashFrequency=Weekly&trashQuantity=2&startDate=2026-04-15
      - Residential Trash with partial params (only containerSize)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0009&trashContainerSize=64

      Residential Recycling with service details pre-selection (S0023):
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0023&recyclingContainerSize=96&recyclingFrequency=Every%20other%20week&recyclingQuantity=2

      Residential Trash & Recycling with service details pre-selection (S0013):
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0013&trashContainerSize=64&trashFrequency=Weekly&recyclingContainerSize=64&recyclingFrequency=Weekly

      Residential Food Waste with service details pre-selection (S0007):
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0007&foodContainerSize=32&foodFrequency=Weekly

      Dumpster (Roll-Off) with container pre-selection:
      - Commercial + compactor + id: not passed (no container lookup needed)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0005&customerType=Commercial&containerType=compactor
      - Commercial + openTop + id:5
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0005&customerType=Commercial&containerType=openTop&containerId=5
      - Residential + openTop + id:2
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0005&customerType=Residential&containerType=openTop&containerId=2
      - Contractor + openTop + id:4
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0005&customerType=Contractor&containerType=openTop&containerId=4

      Commercial services with service details pre-selection:
      - Commercial Trash with full params (containerSize=2, frequency=Weekly, quantity=3, startDate)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1009&trashContainerSize=2&trashFrequency=Weekly&trashQuantity=3&startDate=2026-04-01
      - Commercial Trash with partial params (only containerSize)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1009&trashContainerSize=2
      - Commercial Recycling with full params
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1003&recyclingContainerSize=2&recyclingFrequency=Weekly&recyclingQuantity=2
      - Commercial Trash & Recycling with both params
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1013&trashContainerSize=2&trashFrequency=Weekly&recyclingContainerSize=4&recyclingFrequency=Every%20other%20week
      - Commercial Food Waste with params
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1007&foodContainerSize=48&foodFrequency=Weekly&foodQuantity=2

      Commercial Bulk with disposal items (encoded pairs format: bulkItems=itemId1:qty1,itemId2:qty2):
      - Commercial Bulk with 3 items and pickup date (Dryers:2, Refrigerator:1, Sofa:3)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1001&bulkItems=8974f1f6-7e63-49e3-8595-ebffab07f2eb:2,8967e5c2-2aa7-4da1-9899-2da8fd22e059:1,b2985e87-bbf3-47ac-9534-ac9f26f0df7f:3&pickupDate=This%20week
      - Commercial Bulk with 1 item, default quantity (Washing machine)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1001&bulkItems=620dd82d-7191-446b-8aa0-21ed572e2a44&pickupDate=As%20soon%20as%20possible
      - Commercial Bulk with mixed quantities (Microwave:2, Twin Mattress, Recliner:1)
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S1001&bulkItems=3b7e6287-c6dd-4621-a4ce-e6875c13c4b4:2,ac11c3d0-2f0b-4a6a-acae-cd652cb6ac72,4b6b3283-414c-4909-bf40-2ced118762e0:1

      Dumpster (Roll-Off) with service details (deliveryDate, dumpsterQuantity, containerLocation):
      - Dumpster with all params
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Auburn&state=NY&zip=13021&street=24+South+St&latitude=42.9302012&longitude=-76.5656656&code=S0005&customerType=Commercial&containerType=openTop&containerId=2&containerLocation=Driveway&dumpsterQuantity=2&deliveryDate=2026-04-28

      Compactor with service details (compactorMaterials, compactorServiceDate):
      - Compactor with ASAP service date
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0005&customerType=Commercial&containerType=compactor&compactorMaterials=Cardboard&compactorServiceDate=As%20soon%20as%20possible
      - Compactor with specific date
      https://app.casella.com/dev/customerengagement/service-order
        ?city=Burlington&state=VT&zip=05401&street=182+Main+St&latitude=44.48&longitude=-73.22&code=S0005&customerType=Commercial&containerType=compactor&compactorMaterials=Trash&compactorServiceDate=2026-05-01
       */
      const url = new URL(window.location.href); // full current URL
      const params = parseCpaQueryParamsFromUrl(url);

      if (!params) {
        return ROUTER_URLS.root; // redirect to root
      }

      orderStepperService.params = params;
      switch (params.code) {
        case ServiceCode.CommercialRecycling:
        case ServiceCode.CommercialTrashAndRecycling:
        case ServiceCode.CommercialBulk:
        case ServiceCode.CommercialFoodWaste:
        case ServiceCode.CommercialTrash:
          return `/${ROUTER_URLS.commercial}`;
        case ServiceCode.BulkPickupTownServiceDetailDto:
        case ServiceCode.FoodWasteTownServiceDetailDto:
        case ServiceCode.TrashPickUpTownServiceDetailDto:
        case ServiceCode.TrashPickUpAndRecyclingTownServiceDetailDto:
        case ServiceCode.RecyclingTownServiceDetailDto:
          return `/${ROUTER_URLS.residential}`;
        case ServiceCode.RollOff:
          return `/${ROUTER_URLS.rollOff}`;
        default:
          return `/${ROUTER_URLS.root}`;
      }
    },
  },
  {
    path: ROUTER_URLS.residential,
    loadChildren: () => import('@portal/residential-service').then((c) => c.residentialServiceRoutes),
  },
  {
    path: ROUTER_URLS.rollOff,
    loadChildren: () => import('@portal/roll-off').then((c) => c.rollOffRoutes),
  },
  {
    path: ROUTER_URLS.commercial,
    loadChildren: () => import('@portal/commercial').then((c) => c.commercialRoutes),
  },
  {
    path: ROUTER_URLS.congratulations,
    loadComponent: () =>
      import('../components/congratulations/congratulations.component').then((c) => c.CongratulationsComponent),
  },
  {
    path: ROUTER_URLS.demo,
    // eslint-disable-next-line @nx/enforce-module-boundaries
    loadComponent: () => import('../../../../libs/portal/ui-demo/src/index').then((c) => c.UiDemoComponent),
  },
  {
    path: ROUTER_URLS.error500,
    loadComponent: () => import('../components/error-500/error-500.component').then((c) => c.Error500Component),
  },
  {
    path: ROUTER_URLS.error404,
    loadComponent: () => import('../components/error-404/error-404.component').then((c) => c.Error404Component),
  },
];
